module.exports = __webpack_public_path__ + "static/media/IMG_0645.1966a7b8.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/modra/IMG_0645.JPG
// module id = 91
// module chunks = 0